module.exports = __webpack_public_path__ + "media/images/lineup__stat__percPicked-d3a07a3052de79027102321add2a6fdd.png";